const $ = require('jquery');
/**
 * pheromonfallen_getArt
 * @param element
 * @param scopeID
 */
window.pheromonfallen_getArt = function(element, scopeID) {
  if ($(element).find(':selected').val() === '') {
    pheromonfallen_resetSelectFields(element, scopeID);
    return;
  }

  const row = $(element).closest('div.psm-mittel-row');
  const mittelgroups = $(element).find(':selected').attr('data-mittelgroups');
  const tempSelected = row.find('select.art option:selected').val();

  row.find('select.art').empty().append('<option value="">---</option>');

  if (mittelgroups) {
    const payload = {
      type: scopeID,
      mittelgroups: mittelgroups,
    };

    $.getJSON(BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getMittelgroup', payload, function(data) {
      let FocusNextField = false;
      const selectArt = row.find('select.art');

      $.each(data, function(k, v) {
        let selectHtml = '';
        if (v.code === tempSelected) {
          selectHtml = ' selected';
          FocusNextField = true;
        } else if (data.length === 1) {
          selectHtml = ' selected';
          FocusNextField = true;
        }

        selectArt.append('<option value="' + v.code + '" data-indications="' + v.indications + '"' + selectHtml + '>' + v.name + '</option>');
      });

      if (!FocusNextField) {
        selectArt.focus();
      } else {
        row.find('input.ergebnis').focus();
      }
    });
  }
};

/**
 * pheromonfallen_getZaehlung
 * @param element
 * @param scopeID
 */
window.pheromonfallen_getZaehlung = function(element, scopeID) {
  if ($(element).find(':selected').val() === '') {
    pheromonfallen_resetSelectFields(element, scopeID);
    return;
  }

  const row = $(element).closest('div.psm-mittel-row');
  const indications = $(element).find(':selected').attr('data-indications');
  const tempSelected = row.find('select.zaehlung option:selected').val();

  row.find('select.zaehlung').empty().append('<option value="">---</option>');

  if (indications) {
    $.ajax({
      url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getIndications?type=' + scopeID,
      type: 'get',
      data: {
        indications: indications,
      },
      success: function(data) {
        const result = $.parseJSON(data);
        let FocusNextField = false;

        $.each(result, function(k, v) {
          let selectHtml = '';
          if (v.code === tempSelected) {
            selectHtml = ' selected';
            FocusNextField = true;
          }

          row.find('select.zaehlung').append('<option value="' + v.code + '" data-mittelgroups="' + v.mittelgroups + '"' + selectHtml + '>' + v.name + '</option>');
        });

        if (FocusNextField === false) {
          row.find('select.zaehlung').focus();
        } else {
          row.find('input.ergebnis').focus();
        }
      },
    });
  }
};

/**
 * pheromonfallen_getEinheit
 * @param element
 * @param scopeID
 */
window.pheromonfallen_getEinheit = function(element, scopeID) {
  if ($(element).find(':selected').val() === '') {
    pheromonfallen_resetSelectFields(element, scopeID);
    return;
  }

  const row = $(element).closest('div.psm-mittel-row');
  const value = parseInt($(element).find(':selected').val());
  const tempSelected = row.find('select.einheit option:selected').val();
  const selectEinheit = row.find('select.einheit');

  selectEinheit.empty().append('<option value="">---</option>');

  /**
   * refreshArtOnKontrolldatumChange
   */
  function refreshArtOnKontrolldatumChange() {
    $(obj).trigger('change');
    $(this).off('refreshArtOnKontrolldatumChange');
  }

  if (value) {
    const payload = {
      zaehlung: value,
      type: scopeID,
    };

    $.getJSON(BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getEinheiten', payload, function(data) {
      $.each(data, function(k, v) {
        const selectHtml = (v.code === tempSelected || data.length === 1) ? ' selected' : '';

        selectEinheit.append('<option value="' + v.code + '"' + selectHtml + '>' + v.name + '</option>');
      });

      const kontrolldatumEl = $('#aufzeichnung-einsatzdatum-start');
      const kontrolldatum = kontrolldatumEl.val().split('-');
      const kontrolldatumTag = parseInt(kontrolldatum[2]);
      const kontrolldatumMonat = parseInt(kontrolldatum[1]);

      const dataFruechte = $('#einheit-fruechte');
      const fruechteID = dataFruechte.data('code');
      const fruechteName = dataFruechte.data('name');

      const dataTriebe = $('#einheit-triebe');
      const triebeID = dataTriebe.data('code');
      const triebeName = dataTriebe.data('name');

      // AGRIOS 2019 - 4. Primärschorf; 113 => Apfelschorf
      if (value === 113 && kontrolldatumTag <= 30 && kontrolldatumMonat <= 6) {
        // vor/gleich dem 30.06.
        selectEinheit.empty().append('<option value="">---</option><option value="' + triebeID + '" selected>' + triebeName + '</option>');

        // doppeltes Hinzufügen vom eventListener vermeiden, da sonst die option-Elemente mehrfach auftauchen
        if (!kontrolldatumEl.attr('data-has-listener')) {
          kontrolldatumEl.on('change', refreshArtOnKontrolldatumChange).attr('data-has-listener', true);
        }
      }

      // AGRIOS 2019 - 5. Einheiten; 15 => Fruchtschalenwickler
      if (value === 15) {
        // nach 31.05.
        if (kontrolldatumTag >= 1 && kontrolldatumMonat > 5) {
          selectEinheit.find('option[value="' + triebeID + '"]').remove();

          // option nur hinzufügen falls noch nicht existent
          if (selectEinheit.find('option[value="' + fruechteID + '"]').length === 0) {
            selectEinheit.append('<option value="' + fruechteID + '" selected>' + fruechteName + '</option>');
          }

          if (!kontrolldatumEl.attr('data-has-listener')) {
            kontrolldatumEl.on('change', refreshArtOnKontrolldatumChange).attr('data-has-listener', true);
          }
          return;
        }

        // zwischen 01.01. und 31.05.
        if (kontrolldatumTag >= 1 && kontrolldatumMonat >= 1) {
          selectEinheit.find('option[value="' + fruechteID + '"]').remove();

          // option nur hinzufügen falls noch nicht existent
          if (selectEinheit.find('option[value="' + triebeID + '"]').length === 0) {
            selectEinheit.append('<option value="' + triebeID + '" selected>' + triebeName + '</option>');
          }

          if (!kontrolldatumEl.attr('data-has-listener')) {
            kontrolldatumEl.on('change', refreshArtOnKontrolldatumChange).attr('data-has-listener', true);
          }
        }
      }
    });
  }
};

/**
 * pheromonfallen_resetSelectFields
 * @param element
 * @param scopeID
 */
window.pheromonfallen_resetSelectFields = function(element, scopeID) {
  const row = $(element).closest('div.psm-mittel-row');

  $.getJSON(BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getAllIndicationsMittelgroups', {
    type: scopeID,
  }, function(data) {
    const indications = data.indications;
    const mittelgroups = data.mittelgroups;

    const selectZaehlung = row.find('select.zaehlung');
    const selectArt = row.find('select.art');

    selectZaehlung.empty().append('<option value="">---</option>');
    selectArt.empty().append('<option value="">---</option>');

    $.each(indications, function(k, v) {
      selectZaehlung.append('<option value="' + v.indication_code + '" data-mittelgroups="' + v.mittelgroups + '">' + v.indication_name + '</option>');
    });

    $.each(mittelgroups, function(k, v) {
      selectArt.append('<option value="' + v.mittelgroup_code + '" data-indications="' + v.indications + '">' + v.mittelgroup_name + '</option>');
    });
  });

  const payload = {
    zaehlung: 0,
    type: scopeID,
  };

  $.getJSON(BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getEinheiten', payload, function(data) {
    const selectEinheit = row.find('select.einheit');
    selectEinheit.empty().append('<option value="">---</option>');

    $.each(data, function(k, v) {
      selectEinheit.append('<option value="' + v.code + '">' + v.name + '</option>');
    });
  });
};

/**
 * pheromonfallen_buildMittelRow
 * @param json
 * @param divElement
 */
window.pheromonfallen_buildMittelRow = function(json, divElement) {
  // Template
  let template = $('#mittel-row').html();

  $.each(json, function(k, v) {
    if (k === '__BEMERKUNG__') {
      v = v.replace(/<br ?\/?>/g, '\n');
    }
    template = template.replace(new RegExp(k, 'g'), v);
  });

  if ($(divElement).find('div[data-row-key="' + json.__KEY__ + '"]').length > 0) {
    $(divElement).find('div[data-row-key="' + json.__KEY__ + '"]').replaceWith(template);
  } else {
    $(divElement).append(template);
  }
};

/**
 * pheromonfallen_buildAbschnittMittelRow
 * @param json
 * @param divElement
 */
window.pheromonfallen_buildAbschnittMittelRow = function(json, divElement) {
  const checkedAbschnitte = $(divElement).find('input.check_section[type="checkbox"]:checked');
  if (checkedAbschnitte.length > 0) {
    checkedAbschnitte.each(function() {
      const detailMittel = $(this).closest('.tree-item').find('div.table-mittel-abschnitt');

      // Template
      let template = $('#mittel-abschnitt-row').html();

      $.each(json, function(k, v) {
        template = template.replace(new RegExp(k, 'g'), v);
      });

      template = template.replace(new RegExp('__SECTION_ID__', 'g'), $(this).val());

      if (json.__ROW_ID__ !== '' && detailMittel.find('div.row[data-section-uid="' + $(this).val() + '"][data-row-id="' + json.__ROW_ID__ + '"]').length > 0) {
        detailMittel.find('div.row[data-section-uid="' + $(this).val() + '"][data-row-id="' + json.__ROW_ID__ + '"]').replaceWith(template);
      } else if (detailMittel.find('div.row[data-section-uid="' + $(this).val() + '"][data-row-id="' + json.__KEY__ + '"]').length > 0) {
        detailMittel.find('div.row[data-section-uid="' + $(this).val() + '"][data-row-id="' + json.__KEY__ + '"]').replaceWith(template);
      } else {
        detailMittel.append(template);
      }
    });
  }
};